module.exports = __webpack_public_path__ + "assets/img/th-552b3032.png";